import React from 'react'
import {UNFILTEREDTEXT} from '../utils/constants'

const Items = props => {  
    if (props.categories.length === 0) {
      return "Loading..."
    }    
    return props.categories
      .slice(0, props.numberOfitemsShown)      
      .map((category, index) =>
        index === props.categories.length -1 
            ? <span className='category_text' key={category.id}>{category.name} </span>
             : <span className='category_text' key={category.id}>{category.name}, </span>)
  }
class Category extends React.Component {
    constructor() {
      super()      
      this.state = {
        itemsShown: 1     
      }
    }

    showMore = () => {      
      this.setState({ itemsShown: this.props.items.length })      
    }
  
    render() {
      if(this.state.itemsShown < this.props.numberOfitemsShown){
        this.state.itemsShown = this.props.numberOfitemsShown
      }      
      let remainingItems =  this.props.items.length - this.state.itemsShown
      return (
        <div className="card_body_row">
          <div className="title_wrapper">
            <label htmlFor={this.props.title}>
            <div className='category_label'>{this.props.title}</div>
            </label>
          </div>
          <div className="items_wrapper">
            {(this.props.items && this.props.items.length) ? 
            <Items categories={this.props.items.sort((a, b) => a.name.localeCompare(b.name))} numberOfitemsShown={this.state.itemsShown} />  : 
                <div className='category_text'>{UNFILTEREDTEXT}</div> }      
            { this.state.itemsShown < this.props.items.length && 
            <a onClick={this.showMore}>
            <span className='category_text'>and </span><span className='category_more'>{remainingItems} more</span>
            </a>}
          </div>
        </div>
      );
    }
  }

  export default Category